import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { JsonControl, JsonControlItemCustomOptions } from '../model';

@Component({
  selector: 'jsonform-form-control-select',
  templateUrl: './form-control-select.component.html',
  styleUrls: ['./form-control-select.component.scss'],
  standalone: false,
})
export class FormControlSelectComponent {
  @Input() public control!: FormControl | any;
  @Input() public opciones: JsonControlItemCustomOptions[] = [];
  @Input() public jsonControl!: JsonControl;
}
